import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "video", "preview", "result",
    "livePanel", "placeholder",
    "btnStart", "btnCapture", "btnRetake"
  ]

  static values = { existingPhotoUrl: String }

  connect() {
    console.log("[Camera] connect()")
    this.stream = null
    const existing = this.existingPhotoUrlValue?.trim() || ""

    if (existing.length > 0) {
      console.log("[Camera] → foto existente:", existing)
      this._showPanel()
      this.previewTarget.src = existing
      this.previewTarget.style.display = "block"
      this._hidePlaceholder()
      if (this.hasBtnStartTarget)   this.btnStartTarget.style.display   = "none"
      if (this.hasBtnCaptureTarget) this.btnCaptureTarget.style.display = "none"
      if (this.hasBtnRetakeTarget)  this.btnRetakeTarget.style.display  = "inline-block"
    }
  }

  disconnect() {
    this._stopStream()
  }

  async start() {
    console.log("[Camera] start()")
    if (!navigator.mediaDevices?.getUserMedia) {
      console.warn("[Camera] getUserMedia não suportado")
      return
    }

    try {
      this._stopStream()
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user", width: { ideal: 640 }, height: { ideal: 480 } },
        audio: false
      })
      console.log("[Camera] stream obtido")

      this._showPanel()
      this._hidePlaceholder()

      // esconde preview, mostra vídeo
      this.previewTarget.style.display = "none"
      this.videoTarget.style.display   = "block"
      this.videoTarget.srcObject = this.stream

      if (this.hasBtnStartTarget)   this.btnStartTarget.style.display   = "none"
      if (this.hasBtnCaptureTarget) this.btnCaptureTarget.style.display = "inline-block"
      if (this.hasBtnRetakeTarget)  this.btnRetakeTarget.style.display  = "none"

    } catch (e) {
      console.error("[Camera] Erro ao acessar câmera:", e.name, e.message)
    }
  }

  capture() {
    console.log("[Camera] capture()")
    const video = this.videoTarget
    const canvas = document.createElement("canvas")
    canvas.width  = video.videoWidth  || 640
    canvas.height = video.videoHeight || 480

    const ctx = canvas.getContext("2d")
    ctx.translate(canvas.width, 0)
    ctx.scale(-1, 1)
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

    const dataUrl = canvas.toDataURL("image/jpeg", 0.92)
    console.log("[Camera] capturado, tamanho:", dataUrl.length)

    // para o stream e mostra o preview no mesmo painel
    this._stopStream()
    this.videoTarget.style.display   = "none"
    this.previewTarget.src           = dataUrl
    this.previewTarget.style.display = "block"
    this.resultTarget.value          = dataUrl

    if (this.hasBtnCaptureTarget) this.btnCaptureTarget.style.display = "none"
    if (this.hasBtnRetakeTarget)  this.btnRetakeTarget.style.display  = "inline-block"
  }

  retake() {
    console.log("[Camera] retake()")
    this.resultTarget.value          = ""
    this.previewTarget.style.display = "none"
    this.previewTarget.removeAttribute("src")
    this.start()
  }

  _showPanel() {
    if (this.hasLivePanelTarget) {
      this.livePanelTarget.style.display = "block"
    }
  }

  _hidePlaceholder() {
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.style.display = "none"
    }
  }

  _stopStream() {
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop())
      this.stream = null
    }
    if (this.hasVideoTarget) this.videoTarget.srcObject = null
  }
}